// ============================================================
// PageHeader — Page Title + Breadcrumb + Actions + Back Button
// ============================================================

import { Box, Typography, Button } from '@mui/material';
import { Breadcrumb } from './Breadcrumb';
import { Plus, ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { tokens } from '@/theme/tokens';

export function PageHeader({
  title,
  subtitle,
  breadcrumbs = [],
  actionLabel,
  actionIcon: ActionIcon = Plus,
  onAction,
  action,
  actions,
  backPath,
  onBack,
  backLabel = 'Back to Settings',
}) {
  const navigate = useNavigate();
  const handleBack = onBack || (backPath ? () => navigate(backPath) : null);

  return (
    <Box sx={{ mb: 3 }}>
      {breadcrumbs.length > 0 && (
        <Box sx={{ mb: 1.5 }}>
          <Breadcrumb items={breadcrumbs} />
        </Box>
      )}
      <Box
        sx={{
          display: 'flex',
          alignItems: { xs: 'flex-start', sm: 'center' },
          justifyContent: 'space-between',
          flexDirection: { xs: 'column', sm: 'row' },
          gap: 2,
        }}
      >
        <Box>
          <Typography variant="h4" fontWeight={700}>
            {title}
          </Typography>
          {subtitle && (
            <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
              {subtitle}
            </Typography>
          )}
        </Box>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, flexShrink: 0, flexWrap: 'wrap' }}>
          {handleBack && (
            <Button
              variant="outlined"
              startIcon={<ArrowLeft size={18} />}
              onClick={handleBack}
              sx={{
                borderRadius: tokens.radius.button,
                textTransform: 'none',
                fontWeight: 600,
              }}
            >
              {backLabel}
            </Button>
          )}
          {action}
          {actions}
          {actionLabel && onAction && (
            <Button
              variant="contained"
              startIcon={<ActionIcon size={18} />}
              onClick={onAction}
            >
              {actionLabel}
            </Button>
          )}
        </Box>
      </Box>
    </Box>
  );
}
